/**
 * Max file size validation
 * @param size file size in bytes
 */
export const maxFileSize = (size) => (file) => {
    if (file && file.size > size && size > 0) {
        return { message: `File cannot be larger than ${size / (1000 * 1000)}MB.` };
    }
    return;
};
//# sourceMappingURL=maxFileSize.js.map